import React from 'react';
import { Material } from '../../../../sp-types/materialType';
import { Product } from '../../../../sp-types/productType';

interface IProductOverviewMaterialBreakdownProps {
  currentProduct: Product;
  materialsMap: Record<string, Material>;
  materialColorDictionary: Record<string, string>;
}
export const ProductOverviewMaterialBreakdown: React.FC<IProductOverviewMaterialBreakdownProps> = ({
  currentProduct,
  materialsMap,
  materialColorDictionary,
}) => {
  return (
    <div className="flex flex-col  ">
      <h6 className="text-red text-lg">Materials</h6>
      <div className="grid grid-cols-3 justify-between   overflow-auto ">
        {['Material', 'Quantity per unit', 'Price per ton'].map((item, index) => (
          <p key={'a' + index} className="text-sm text-secondary_text  ">
            {item}
          </p>
        ))}
        {currentProduct.ingredients.map((item, index) => (
          <React.Fragment key={'b' + index}>
            <div
              style={{
                borderLeft: `6px solid ${materialColorDictionary[item.materialID]}`,
              }}
              className="h-10 content-center ps-2 my-1"
            >
              {materialsMap[item.materialID].name}
            </div>
            <div className="content-center">{item.weightInProduct?.toLocaleString() || ''} ton</div>
            <div className="content-center">${materialsMap[item.materialID].currentPrice.toLocaleString()}</div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
